import * as types from '../actions/typeNames'

const InitialState = {    
    presentations: [],
    answers: {
        all: {
            items: [],
            page: 1,
            pageSize: 20,
            total: 0
        }
    },
    selectedPresentation: {
        PresentationId: -1,
        EncryptedId: "",
        Name: "All"
    },
    selectedAnswer: null,
    itemPresAll: {
        PresentationId: -1,
        EncryptedId: "",
        Name: "All"
    },
    answerModel:{},
    loader: false
}

const answers = (state = InitialState, action) => {
    switch(action.type){
        case types.SET_PRESENTATION_LIST:
            return {
                ...state,
                presentations: [...action.presentations]
            }
        case types.SELECT_PRESENTATION:
            return{
                ...state,
                selectedPresentation: {...action.presentation},
                selectedAnswer: null
            }
        case types.SET_ANSWER_LIST:
            return setAnswerList(state, action.answers, action.total, action.page)
        case types.SELECT_ANSWER:
            return {
                ...state,
                selectedAnswer: action.answer
            }
        case types.SET_ANSWER:
            return {
                ...state,
                answerModel: action.answerModel
            }
        case types.SET_ANSWERS_LOADER:
            return {
                ...state,
                loader: action.flag
            }
        default:            
            return state       
    }
}

const setAnswerList = (state, list, total, page) => {
    if(state.selectedPresentation.PresentationId > 0){
        let id = state.selectedPresentation.PresentationId
        let answs = {...state.answers}
        answs[id] = {
            items: [...list],
            page,
            total
        }
        return {
            ...state,
            answers: answs
        }
    }else{
        return {
            ...state,
            answers: {
                ...state.answers,
                all: {
                    items: [...list],
                    page,
                    total 
                }
            }
        }
    }
}

export default answers;